module.exports = __webpack_public_path__ + "static/media/teen-burger-3-hero-desktop.5d612c6c.jpg";